module.exports = __webpack_public_path__ + "static/media/feather.b23df4db.svg";